import styles from './Step.module.scss'
import { useRef } from 'react'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

export interface StepDetail {
  no: string
  title: string
  text: string
}

export interface StepItem {
  sectionTitle: string
  sectionRead?: string
  step: StepDetail[]
}

interface Props {
  StepEach: StepItem[]
}

const Step: React.FC<Props> = ({ StepEach }) => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  const item = StepEach && StepEach.length > 0 ? StepEach[0] : { sectionTitle: '', sectionRead: '', step: [] }

  return (
    <section
      className={`${styles.step} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <h2 className={styles.sectionTitle}>{item.sectionTitle}</h2>
      <p className={styles.sectionRead}>{item.sectionRead}</p>
      <ul className={styles.stepList}>
        {item.step &&
          item.step.map((step, index) => (
            <li key={index} className={styles.stepList__item}>
              <div className={styles.stepList__item__no}>{step.no}</div>
              <div className={styles.stepList__item__area}>
                <h3 className={styles.stepList__item__area__title}>{step.title}</h3>
                <p className={styles.stepList__item__area__text}>{step.text}</p>
              </div>
            </li>
          ))}
      </ul>
    </section>
  )
}

export default Step
